import { Frame, Loader, View } from '@klarna/bubble-ui';
import React from 'react';
const LoadingComponent = () => (React.createElement(View, { style: { width: '100%', marginBottom: '25px' } },
    React.createElement(Frame, null,
        React.createElement("div", { "data-testid": 'widget_loading', style: { minHeight: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement(Loader, null)))));
export default LoadingComponent;
